// extracted by mini-css-extract-plugin
module.exports = {"container":"svgIcon-module--container--2Eyq3"};